<script>
import { createNamespacedHelpers } from 'vuex';
import { Lodash } from '@intelipost-js/secure-providers';
import {
  ScTable,
  ScTableColumn,
  ScTableEmpty,
  ScDropdown,
  ScDropdownItem,
} from '@intelipost-js/secure-components';
import ScConfirmationModal from '../../../../../components/sc-confirmation-modal/ScConfirmationModal.vue';

const { mapActions } = createNamespacedHelpers('recon/billing');

export default {
  name: 'BillingTemplatesTable',
  data() {
    return {
      confirmationModalActive: false,
      templateSelectedForRemoval: undefined,
      emptyTableTemplate: `
        <p style="font-weight: bold; font-size: 1.5em">Nenhuma fatura encontrada</p>
      `,
    };
  },
  methods: {
    ...mapActions(['removeBillingTemplate']),
    getTemplateLogisticProviderInfo(template) {
      const deliveryMethods = this.$store.getters['logisticProviders/allDeliveryMethods'] || [];
      const templateDM = deliveryMethods.find(dm => dm.id === template.deliveryMethodId);
      return templateDM && `${templateDM.logistic_provider_name} - ${templateDM.name}`;
    },
    selectForDeletion(templateId) {
      this.confirmationModalActive = true;
      this.templateSelectedForRemoval = templateId;
    },
  },
  async created() {
    if (Lodash.isEmpty(this.$store.getters['logisticProviders/allDeliveryMethods'])) {
      await this.$store.dispatch('logisticProviders/getLogisticProviders', false);
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    templates: {
      type: Array,
      required: true,
    },
  },
  components: {
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScDropdown,
    ScDropdownItem,
    ScConfirmationModal,
  },
};
</script>

<template>
  <section>
    <sc-confirmation-modal
      :is-active.sync="confirmationModalActive"
      type="danger"
      title="Excluir modelo"
      confirm-text="Sim, excluir"
      :messages="[
        'Tem certeza que deseja excluir o modelo de fatura?',
        'Caso queira fazer auditoria de fatura dessa transportadora novamente, basta criar um novo modelo.'
      ]"
      @onConfirm="() => removeBillingTemplate(templateSelectedForRemoval)"
    />

    <sc-table
      id="billing-templates-table"
      :loading="loading" :data="templates"
      :bordered="false" :hoverable="false" :striped="false" :scrollable="false">
      <template slot-scope="{ row }">
        <sc-table-column label="Transportadora e método de entrega" :centered="false">
          {{ getTemplateLogisticProviderInfo(row) }}
        </sc-table-column>
        <sc-table-column label="Nome do modelo" :centered="false">
          {{ row.name }}
        </sc-table-column>
        <sc-table-column label="Criado em" :centered="false">
          {{ row.created | date('DD/MM/YY - HH:mm') }}
        </sc-table-column>
        <sc-table-column label="Ações" width="80">
          <sc-dropdown position="is-bottom-left">
            <div class="field" slot="trigger">
              <i class="fas fa-ellipsis-v"></i>
            </div>
            <sc-dropdown-item has-link>
              <router-link class="template-action" :to="{ name: 'create-billing-template', query: { view: row.id } }">
                <i class="far fa-eye"></i> Visualizar modelo
              </router-link>
            </sc-dropdown-item>
            <sc-dropdown-item separator/>
            <sc-dropdown-item class="template-action" @click="selectForDeletion(row.id)">
              <i class="far fa-times-circle"></i> Excluir modelo
            </sc-dropdown-item>
          </sc-dropdown>
        </sc-table-column>
      </template>
      <template slot="empty">
        <sc-table-empty icon="box-open" :message="emptyTableTemplate"/>
      </template>
    </sc-table>
  </section>
</template>

<style lang="scss">
#billing-templates-table {
  .table-wrapper {
    overflow-x: unset;
  }

  .template-action {
    font-size: 14px;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/files/components/BillingTemplatesTable.vue